export const getResultPropKey = resultPropName => resultPropName ? "_" + resultPropName : '_observationResultsData';
//# sourceMappingURL=getResultPropKey.js.map